import Resource from '@/api/resources/Resource'

class PetitionerConfigurationServices extends Resource {
    async paginator(filterModel, params) {
        const response = await this.axios.put(`/configuration/petitioners`, filterModel, { params })
        return response.data
    }
    async getPetitionersByName(params) {
        const response = await this.axios.get(`/configuration/petitioners/search`, { params })
        return response.data
    }
    async getPetitionerById(petitionerId) {
        const response = await this.axios.get(`/configuration/petitioners/${petitionerId}`)
        return response.data
    }
    async patchPetitionerBatch(petitioner) {
        const response = await this.axios.patch(`/configuration/petitioners/batch`, petitioner)
        return response.data
    }
    async createPetitioner(petitioner) {
        const response = await this.axios.post(`/configuration/petitioners`, petitioner)
        return response.data
    }
    async deletePetitionersBatch(petitioners) {
        const data = {
            entityIdentifiers: petitioners
        }
        const response = await this.axios.delete(`/configuration/petitioners/batch`, { data: data })
        return response.data
    }
}

export default new PetitionerConfigurationServices()
